
import { defineComponent } from "vue";
import { translate } from "@/hooks/TranslateService";

export default defineComponent({
  name: "",
  components: {},
  setup() {
    return {
      translate
    }
  },
});
